var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showActivator)?_c('div',{staticClass:"ml-2",on:{"click":_vm.activateWizard}},[_c('InfoIcon',{attrs:{"size":20,"text":_vm.$t('views.common.wizardAlertActivator.activate'),"maxWidth":500}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }